import { Benchmark, RoiState, Sector } from "./types";

export const benchmarks: Record<Sector, Benchmark> = {
  manifatturiero: { recoveryRate: 0.65, reworkHoursPerError: 2, preventableErrorRate: 0.45 },
  sanita: { recoveryRate: 0.55, reworkHoursPerError: 2.5, preventableErrorRate: 0.4 },
  legale: { recoveryRate: 0.62, reworkHoursPerError: 3, preventableErrorRate: 0.45 },
  altro: { recoveryRate: 0.5, reworkHoursPerError: 1.5, preventableErrorRate: 0.35 },
};

export const sectorLabels: Record<Sector, string> = {
  manifatturiero: "Manifatturiero",
  sanita: "Sanita / Healthcare",
  legale: "Legale / Professionale",
  altro: "Altro",
};

export const roiWizardSteps = ["Profilo", "Situazione attuale", "Risultati"];

export const initialRoiState: RoiState = {
  sector: "manifatturiero",
  employees: 50,
  processes: 100,
  weeklyHours: 20,
  hourlyCost: 35,
  monthlyErrors: 15,
};

export const formatNumber = (value: number) => Math.round(value).toLocaleString("it-IT");

export const formatMoney = (value: number) =>
  `${formatNumber(value)} EUR`;

export const flowentiSubscriptionPlans = [
  { name: "Base", monthlyCost: 39, processLimit: 200 },
  { name: "Standard", monthlyCost: 79, processLimit: 500 },
  { name: "Premium", monthlyCost: 179, processLimit: 1000 },
];

export function getFlowentiAnnualCost(processes: number) {
  const selectedPlan =
    flowentiSubscriptionPlans.find((plan) => processes <= plan.processLimit) ||
    flowentiSubscriptionPlans[flowentiSubscriptionPlans.length - 1];

  return {
    annualCost: selectedPlan.monthlyCost * 12,
    planName: selectedPlan.name,
    processLimit: selectedPlan.processLimit,
  };
}

export function calculateRoi(state: RoiState) {
  const benchmark = benchmarks[state.sector];
  const flowentiCost = getFlowentiAnnualCost(state.processes);
  const timeSavings =
    state.weeklyHours *
    52 *
    state.hourlyCost *
    benchmark.recoveryRate *
    0.35;
  const errorSavings =
    state.monthlyErrors *
    12 *
    state.hourlyCost *
    benchmark.reworkHoursPerError *
    benchmark.preventableErrorRate;
  const totalSavings = timeSavings + errorSavings;
  const roi = Math.round(((totalSavings - flowentiCost.annualCost) / flowentiCost.annualCost) * 100);
  const paybackMonths = Math.max(1, Math.round(flowentiCost.annualCost / (totalSavings / 12)));
  const recoveredHours = Math.round(
    state.weeklyHours * 52 * benchmark.recoveryRate * 0.35
  );

  return {
    timeSavings,
    errorSavings,
    totalSavings,
    flowentiCost: flowentiCost.annualCost,
    flowentiPlanName: flowentiCost.planName,
    flowentiPlanProcessLimit: flowentiCost.processLimit,
    roi,
    paybackMonths,
    recoveredHours,
  };
}
